import * as  moment from 'moment';

export class DetalleCaso {
    public caso: ModelCaso;
    public transacciones: ModelTransaccion[];
    public transaccion: ModelTransaccion[];

    constructor() {
        this.caso = new ModelCaso();
        this.transacciones = [];
    }
}

export class ModelCaso {
    public CasoId: number;
    public Nombre: string;
    public FechaRegistro: string;
    public AlertaTipo: string;
    public AlertaId: number;
    public Monto: number;
    public ClaveCia: string;
    public PersonaId: number;
    public TipoCaso: number;
    public EsCoincidencia: number;
    public MotivoReporte: string;
    public Coincidencias: string;
    public Descripcion: string;
    public Comentarios: string;
    public Detalle: string;
    public TipoReporteId: string;
    public TipoReporteCadena: string;
    public TipoPersona: number;
    public PuntajeRiesgo: number;

    constructor() {
        const formatoSalida = 'YYYY-MM-DD';
        const formatoEntrada = 'YYYY-MM-DDTHH:mm:ss Z';
        const FechaRegistro = moment(new Date(new Date().getFullYear(),
            new Date().getMonth(), new Date().getDate()), formatoEntrada);
        this.FechaRegistro = FechaRegistro.format(formatoSalida);
        this.Comentarios = '';
        this.Descripcion = '';
        this.MotivoReporte = '';
    }
}

export class ModelAtendenderCaso {
    public CasoArray: ModelCasoArray[];
    public UsuarioId: number;
    public EsRolAdminAtender: boolean;

    constructor() {
        this.CasoArray = [];
        this.UsuarioId = -1;
        this.EsRolAdminAtender = false;
    }
}

export class ModelCasoArray {
    public CasoId: number;
    public EsRolAdminAtender: boolean;

    constructor() {
        this.CasoId = -1;
        this.EsRolAdminAtender = false;
    }
}

export class ModelCasoInusual {
    public personaId: number;
    public nombre: string;
    public tipoPersona: number;

    constructor() {
        this.personaId = -1;
        this.nombre = "";
        this.tipoPersona = -1;
    }
}

export class ModelTransaccion {
    public nombre: string;
    public sNombre: string;
    public apellidoPaterno: string;
    public apellidoMaterno: string;
    public tipoOperacion: string;
    public divisa: string;
    public saldo: string;
    public tMontoTotal: string;
    public instrumento: string;
    public sucursal: string;
    public fechaRegistro: string;
    public tFechaPago: string;
    public institucionFinanciera: string;
    public tipoCambioDof: string;
    public tipoCambioFix: string;
    public tipoCambioObl: string;
}
